import autoComplete from '@tarekraafat/autocomplete.js';

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
export default class Navigation {
  constructor() {
    this.lastScrollPos = 0;
    this.lengthScrolling = 0;
    this.scrollDirection = 'down';
    this.lang = (prestashop?.language?.iso_code ?? 'en').toLowerCase();
    this.transPhrases = {
      'All results': {
        en: 'All results',
        es: 'Todos los resultados',
      },
      'No results for': {
        en: 'No results for',
        es: 'No hay resultados para',
      },
    };
    this.screenHeight = window.innerHeight;
    this.masthead = document.getElementById('masthead');
    //|| !this.masthead.querySelector('.top-navigation-bar')
    this.mainDomain = this.getSearchDomain();
    this.shopDomain = this.getSearchDomain('store');

    if (!this.masthead || !this.masthead.querySelector('.main-navigation-bar')) {
      return false;
    }

    if (document.readyState === 'loading') {
      // The document is still loading, we can wait for the DOMContentLoaded event
      document.addEventListener('DOMContentLoaded', () => this.start());
    } else {
      this.start();
    }
  }

  getSearchDomain(type = 'marketing') {
    let url = '';


    switch (type) {
      case 'marketing':
        if (typeof urlsObject !== 'undefined') {
          url = (urlsObject?.main ?? 'https://winncom.com');
        } else {
          url = window.location.origin ?? 'https://winncom.com';
        }
        break;
      case 'store':
        if (typeof prestashop !== 'undefined') {
          url = prestashop.urls.base_url.slice(0, -1) ?? 'https://store.winncom.com';
        } else if (window.WINNCOM_SETTINGS) {
          url = window.WINNCOM_SETTINGS['shopUrl' + (window.WINNCOM_SETTINGS.lang_code === 'en' ? 'En' : 'Es')];
        } else {
          url = 'https://store.winncom.com';
        }
    }
    return url;
  }

  start() {
    // this.topNavEl = this.masthead.querySelector('.top-navigation-bar');
    this.topMainEl = this.masthead.querySelector('.main-navigation-bar');
    /**
     * .menu-main-navigation-container = wraper dla topMainEl (ul ..)
     * .sub-menu - kazde sub menu
     */

    document.body.style.setProperty('--max-screen-height', window.outerHeight + 'px');

    window.addEventListener('scroll', () => this.scrollListener());
    window.addEventListener('resize', () => {
      document.body.style.setProperty('--max-screen-height', window.outerHeight + 'px');
    });

    this.scrollListener();
    this.megaMenuItemsListener();
    this.generateStartupModification();
    this.enableWrapLinkBlocker();

    const desktopInput = document.getElementById('searchInputField');
    const mobileInput = document.querySelector('#searchbar-wrapper input[type="text"]');
    const inputs = [desktopInput, mobileInput].filter(Boolean);

    inputs.forEach((el) => {
      this.autocompleteSearchInputManager(el);

      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.location.href = this.shopDomain + '/search?s=' + el.value;
        } else if (e.key === 'Escape') {
          const wrap = el.closest('#searchbar-wrapper');
          if (wrap) wrap.classList.remove('active');
        }
      });
    });

    // desktopowy przycisk lupki
    document.querySelectorAll('button.search-bar-submitter').forEach((btn) => {
      btn.addEventListener('click', () => {
        // spróbuj znaleźć powiązany input w obrębie .search-bar, fallback do desktop/mobile
        const linkedInput = btn.closest('.search-bar')?.querySelector('input[name="s"]') || desktopInput || mobileInput;

        window.location.href = this.shopDomain + '/search?s=' + (linkedInput ? linkedInput.value : '');
      });
    });
    if (window.innerWidth >= 1024) {
      this.showFirstElemsOnSubnav();
    }
  }

  /**
   * Blokuje kliknięcia poza <a> wewnątrz <li data-wrap-link>
   */
  enableWrapLinkBlocker() {
    const navRoot = document.getElementById('site-navigation');
    if (!navRoot) {
      return;
    }

    navRoot.addEventListener('click', function (e) {
      const wrapLi = e.target.closest('li[data-wrap-link]');
      if (!wrapLi) {
        return;
      }

      if (e.target.closest('a')) {
        return;
      }

      e.stopImmediatePropagation();
      e.preventDefault();
    }, true);
  }

  generateStartupModification() {
    if (document.body.classList.contains('hamburger-active')) {
      this.topMainEl.querySelectorAll('.menu-main-navigation-container ul.sub-menu li a').forEach((subLink) => {
        subLink.setAttribute('href', subLink.dataset.targetUrl);
      });
    }
    this.topMainEl.querySelectorAll('.menu-main-navigation-container ul.menu>li').forEach((liElement) => {
      if (liElement.querySelector('.sub-generated-top ul') && liElement.querySelectorAll('.sub-menu>li.generated-item').length) {
        [...liElement.querySelectorAll('.sub-menu>li.generated-item')].map(function (x) {
          liElement.querySelector('.sub-generated-top ul').appendChild(x);
        });
      }

      if (!liElement.querySelector('.sub-wrapper .subnav-nav-col .only-hamburger') && liElement.querySelector('.sub-wrapper .subnav-nav-col')) {
        const a = document.createElement('a');
        a.setAttribute('href', '#'); //liElement.querySelector('a').dataset.targetUrl);
        a.classList.add('only-hamburger');
        a.classList.add('back');
        a.innerText = liElement.querySelector('a').innerText;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          e.target.closest('.mobile-selected').classList.remove('mobile-selected');
          document.body.classList.contains('--sub-menu-open') && document.body.classList.remove('--sub-menu-open');
        });

        liElement.querySelector('.sub-wrapper .subnav-nav-col').prepend(a);
      }
    });
  }

  showFirstElemsOnSubnav() {
    this.topMainEl
      .querySelectorAll('.menu-main-navigation-container ul.menu>li')
      .forEach((liElement) => {
        const wrapper = liElement.querySelector('div.sub-wrapper');
        if (!wrapper) {
          return;
        }

        const firstLink = wrapper.querySelector('.sub-menu>li:not(.generated-item):first-child a');
        if (firstLink) {
          this.showSubMenuElement(firstLink);
        }
      });
  }

  showSubMenuElement(elTarget) {
    const target = elTarget;
    const wrapper = target.closest('.sub-wrapper');
    const pageId = target.dataset.pageId ?? null;
    const termId = target.dataset.termId ?? null;
    const elContentMM = target.closest('.sub-wrapper').querySelector('.subnav-content-col');

    if (!elContentMM) {
      return false;
    }

    if (pageId && document.getElementById('mm-page-' + pageId + '-sub')) {
      elContentMM.innerHTML = '<header class="mm-header"><a href="' + target.getAttribute('href') + '">' + target.innerText + '</a></header>' + '<div class="ccc">' + document.getElementById('mm-page-' + pageId + '-sub').innerHTML + '</div>';
    } else if (pageId && document.getElementById('mm-page-' + pageId)) {
      elContentMM.innerHTML = '<header class="mm-header"><a href="' + target.getAttribute('href') + '">' + target.innerText + '</a></header>' + '<div class="ccc">' + document.getElementById('mm-page-' + pageId).innerHTML + '</div>';
    } else if (termId && document.getElementById('mm-term-' + termId)) {
      elContentMM.innerHTML = document.getElementById('mm-term-' + termId).outerHTML;
      if (elContentMM.querySelector('.mm-header')) {
        elContentMM.querySelector('.mm-header a').setAttribute('href', target.getAttribute('href'));
      }
    } else {
      elContentMM.innerHTML = '';
    }

    const imgUrl = target.dataset.imageUrl ?? null;
    if (imgUrl) {
      const wrap = document.createElement('div');
      wrap.className = 'mm-image-wrapper';
      wrap.innerHTML = `<img src="${imgUrl}" alt="" />`;
      elContentMM.prepend(wrap);
    }

    elContentMM.querySelectorAll('.ccc ul a').forEach((link, _) => {
      const realUrl = link.dataset.targetUrl;
      if (realUrl) {
        link.setAttribute('href', realUrl);
      } else if (link.dataset.act && link.dataset.act === 'forceurl') {
        link.setAttribute('href', target.getAttribute('href') + '?curCatSelected=' + link.dataset.url);
      } else {
        const customAnchor = link.dataset.anchor;
        if (customAnchor && customAnchor.length > 0) {
          link.setAttribute('href', target.getAttribute('href') + customAnchor);
        } else {
          link.setAttribute('href', target.getAttribute('href'));
        }
      }

      // if ( link.dataset.act && link.dataset.act === 'forceurl' ) {
      // 	link.setAttribute( 'href', target.getAttribute( 'href' ) + '?curCatSelected=' + link.dataset.url );
      // } else {
      // 	link.setAttribute( 'href', target.getAttribute( 'href' ) + '#heading-' + _ );
      // }
    });

    if (!wrapper.dataset.mmInit) {
      wrapper.dataset.mmInit = '1';
      const firstLink = wrapper.querySelector('.sub-menu li:first-child a');
      if (firstLink) {
        this.showSubMenuElement(firstLink);
      }
    }
  }

  clearHighlights() {
    this.topMainEl
      .querySelectorAll('.subnav-nav-col a.highlighted')
      .forEach((a) => a.classList.remove('highlighted'));
  }

  megaMenuItemsListener() {
    document.querySelector('#site-navigation .menu-toggle').addEventListener('click', (e) => {
      e.currentTarget.classList.toggle('is-active');
      document.body.classList.toggle('hamburger-active');

      document.querySelector('#site-navigation .mobile-selected') && document.querySelector('#site-navigation .mobile-selected').classList.remove('mobile-selected');
    });

    if (window.innerWidth >= 1024) {
      // 2. Podświetlenie przy najeździe na link w nav-col
      document.querySelectorAll('#site-navigation .subnav-nav-col .sub-menu a')
        .forEach((linkElement) => {
          linkElement.addEventListener('mouseover', (e) => {
            e.preventDefault();
            this.clearHighlights();
            e.target.classList.add('highlighted');
            this.showSubMenuElement(e.target);
          });
        });

      // 3. Podświetlenie “zamrożone”, gdy najedziesz w content-col
      document
        .querySelectorAll('#site-navigation .subnav-content-col > div[id^="mm-term-"]')
        .forEach((contentBlock) => {
          contentBlock.addEventListener('mouseover', () => {
            const termId = contentBlock.id.replace('mm-term-', '');
            this.clearHighlights();
            const navLink = document.querySelector(`#site-navigation .subnav-nav-col a[data-term-id="${termId}"]`);
            if (navLink) {
              navLink.classList.add('highlighted');
            }
          });
        });

      // 4. Gdy opuszczasz całe sub-wrapper, zdejmij wszystkie highlighty
      document
        .querySelectorAll('#site-navigation .sub-wrapper')
        .forEach((wrapper) => {
          wrapper.addEventListener('mouseleave', () => {
            this.clearHighlights();
          });
        });
    } else {
      document.querySelectorAll('#site-navigation .menu > li > a').forEach((linkElement) => {
        linkElement.addEventListener('click', (e) => {
          const link = e.currentTarget;
          const parentLi = link.parentElement;
          const submenu = link.nextElementSibling;

          if (!submenu) {
            return;
          }

          if (parentLi && parentLi.classList.contains('link-force')) {
            return;
          }

          e.preventDefault();

          if (submenu.classList.toggle('mobile-selected')) {
            document.body.classList.add('--sub-menu-open');
          } else {
            document.body.classList.remove('--sub-menu-open');
          }

          submenu.prepend();
        });
      });
      document.querySelectorAll('#site-navigation .subnav-nav-col .sub-menu a').forEach((linkElement) => {
        linkElement.addEventListener('click', (e) => {
          if (!document.body.classList.contains('hamburger-active')) {
            e.preventDefault();
            this.showSubMenuElement(e.target);
          }
        });
      });
    }
  }

  getScrollDirection() {
    return this.scrollDirection;
  }

  getScrollLength() {
    return this.lengthScrolling;
  }

  getAbsoluteScrollValue() {
    return window.scrollY;
  }

  scrollListener() {
    if (this.lastScrollPos < window.scrollY) {
      this.scrollDirection = 'down';
    } else {
      this.scrollDirection = 'top';
    }
    this.lengthScrolling = Math.abs(window.scrollY - this.lastScrollPos);
    this.lastScrollPos = window.scrollY;
  }

  autocompleteSearchInputManager(inputFieldEl) {

    const cacheStore = new Map();
    const CACHE_TTL = 5 * 60 * 1000; // 5 minut

    function getCached(query) {
      const key = String(query || '').trim().toLowerCase();
      if (!key) {
        return null;
      }

      const entry = cacheStore.get(key);
      if (!entry) {
        return null;
      }

      const isExpired = Date.now() - entry.timestamp > CACHE_TTL;
      if (isExpired) {
        cacheStore.delete(key);
        return null;
      }

      return entry.results;
    }

    function setCache(query, results) {
      const key = String(query || '').trim().toLowerCase();
      if (!key) {
        return;
      }

      cacheStore.set(key, {
        results: Array.isArray(results) ? results : [], timestamp: Date.now(),
      });
    }

    function escapeHTML(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function buildUrl(base, path, params = {}) {
      const url = new URL(path, base);

      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          url.searchParams.set(key, value);
        }
      });

      return url.toString();
    }

    async function fetchJSON(url, signal) {
      const response = await fetch(url, {
        method: 'GET', signal, headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status} for ${url}`);
      }

      return response.json();
    }

    function normalizeApiResults(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (Array.isArray(data?.results)) {
        return data.results;
      }

      if (Array.isArray(data?.items)) {
        return data.items;
      }

      if (data && typeof data === 'object') {
        return [data];
      }

      return [];
    }

    function mergeAndSort(...arrays) {
      const flat = arrays.flat().filter(Boolean);

      // deduplikacja po linku albo name
      const uniqueMap = new Map();

      for (const item of flat) {
        const key = `${item.link || ''}::${item.name || ''}`.toLowerCase();
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, item);
        }
      }

      return Array.from(uniqueMap.values()).sort((a, b) => {
        const aName = String(a.name || '').toLowerCase();
        const bName = String(b.name || '').toLowerCase();
        return aName.localeCompare(bName, 'pl');
      });
    }

    const inputFieldSelector = inputFieldEl.getAttribute('id');
    const domainEcommerce = this.shopDomain;
    const domainMarketing = this.mainDomain;
    const shopDomain = this.shopDomain;

    let programmaticRefresh = false;

    let lastQuery = '';
    let currentQuery = '';
    let currentToken = 0;

    let controllerPs = null;
    let controllerWp = null;

    const autoCompleteJS = new autoComplete({
      selector: '#' + inputFieldSelector, debounce: 300, threshold: 2,

      data: {
        src: async (query) => {
          const normalizedQuery = String(query || '').trim();

          if (!normalizedQuery) {
            return [];
          }

          if (programmaticRefresh) {
            return getCached(normalizedQuery) || [];
          }

          const cached = getCached(normalizedQuery);
          if (cached) {
            return cached;
          }

          const sameQuery = normalizedQuery === lastQuery;

          lastQuery = normalizedQuery;
          currentQuery = normalizedQuery;

          if (!sameQuery) {
            currentToken += 1;
          }

          const myToken = currentToken;

          if (!sameQuery) {
            try {
              controllerPs?.abort();
            } catch (_) {
            }

            try {
              controllerWp?.abort();
            } catch (_) {
            }

            controllerPs = new AbortController();
            controllerWp = new AbortController();
          } else {
            controllerPs = controllerPs ?? new AbortController();
            controllerWp = controllerWp ?? new AbortController();
          }

          const psURL = buildUrl(domainEcommerce, 'module/engineautocompleteapi/search', {query: normalizedQuery});

          const wpURL = buildUrl(domainMarketing, 'wp-json/customsearch/v1/products', {query: normalizedQuery});

          const psPromise = fetchJSON(psURL, controllerPs.signal)
            .then((data) => {
              if (myToken !== currentToken || normalizedQuery !== currentQuery) {
                return [];
              }

              const list = normalizeApiResults(data);
              return list.map((item) => ({
                ...item, source: 'PrestaShop', link: item.link || item.url || '#',
              }));
            })
            .catch((err) => {
              if (err?.name !== 'AbortError') {
                console.warn('PS fetch error:', err);
              }
              return [];
            });

          const wpPromise = fetchJSON(wpURL, controllerWp.signal)
            .then((data) => {
              if (myToken !== currentToken || normalizedQuery !== currentQuery) {
                return [];
              }

              const list = normalizeApiResults(data);

              return list.map((item) => ({
                ...item, source: 'WordPress', link: item.link || item.url || '#',
              }));
            })
            .catch((err) => {
              if (err?.name !== 'AbortError') {
                console.warn('WP fetch error:', err);
              }
              return [];
            });

          const [psResults, wpResults] = await Promise.all([psPromise, wpPromise]);

          // jeśli w międzyczasie user wpisał nową frazę, nie pokazuj starego wyniku
          if (myToken !== currentToken || normalizedQuery !== currentQuery) {
            return [];
          }

          const combinedResults = mergeAndSort(psResults, wpResults);

          setCache(normalizedQuery, combinedResults);

          return combinedResults;
        }, cache: false, keys: ['name'], filter: (list) => {
          return list;
        },
      }, searchEngine: (query, record) => record, resultsList: {
        element: (list, data) => {
          list.classList.add('ac-down');

          if (!data.results.length) {
            const message = document.createElement('div');
            message.classList.add('no_result');
            message.innerHTML = '<span>' + this.transPhrases['No results for'][this.lang] + "<strong>${escapeHTML(data.query)}</strong></span>";
            list.appendChild(message);
            return;
          }

          const footer = document.createElement('div');
          footer.className = 'ac-results-footer';
          const link = document.createElement('a');
          link.textContent = this.transPhrases['All results'][this.lang];
          link.setAttribute('role', 'button');
          link.href = '#';

          // zapobiega utracie fokusu przed kliknięciem
          link.addEventListener('pointerdown', (e) => {
            e.preventDefault();
          });

          link.addEventListener('click', (e) => {
            e.preventDefault();

            const s = inputFieldEl ? inputFieldEl.value : data.query || '';
            const searchUrl = buildUrl(shopDomain, '/search', {s});

            autoCompleteJS.unInit();
            window.location.href = searchUrl;
          });

          footer.appendChild(link);
          list.appendChild(footer);

          if (list.hasAttribute('hidden')) {
            list.removeAttribute('hidden');
          }
          footer.style.top = (footer.clientHeight + list.clientHeight - 12) + 'px';
        },

        noResults: true, maxResults: 20, tabSelect: true,
      },

      resultItem: {
        element: (item, data) => {
          const v = data.value || {};

          if (v.id === -1) {
            item.innerHTML = `<span class="error-msg">${escapeHTML(v.name)}</span>`;
            item.setAttribute('aria-live', 'polite');
            return;
          }

          item.dataset.type = v.source ?? 'nn';

          const name = escapeHTML(v.name || '');
          const link = escapeHTML(v.link || '#');
          const img = escapeHTML(v.image || '');

          item.innerHTML = `
        <div style="display:flex;align-items:center;gap:10px;">
          <a class="img" href="${link}" aria-label="${name}">
            <img
              src="${img}"
              width="40"
              height="40"
              alt="${name}"
              style="object-fit:contain;"
              loading="lazy"
            >
          </a>
          <a class="txt" href="${link}">${name}</a>
        </div>
      `;
        },

        highlight: true,
      },
    });
  }
}
